<template>
<div style="height:100%">
  <div id="csContainer">
      <div class="contain1">
     <div style="margin:7px 0 0 22px ">
      <el-input size="small " class="speed" placeholder="时间速率：默认1000" v-model = 'speed' clearable></el-input>
      <el-button class="submit" @click="setSpeed()" size="small "slot="append" icon="el-icon-circle-check" type="primary" >设置</el-button>
      </div>
      <div style='margin:7px 0 0 22px'>
        <el-checkbox class="shadow" size="small " v-model="checked" label="阴影" border></el-checkbox>
        </div>
      </div>
  </div>
  <div id="loadingOverlay"><h1>Loading........</h1></div>
  </div>
</template>
<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'dayTime',
        data(){
            return{
                viewer:null,
                checked:false,
                speed:null,
            }
        },
        mounted(){
             var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
            this.init();
        },
        watch:{
            checked:function (val) {
                this.viewer.shadows = val;
                // this.viewer.clock.multiplier = 10;
            }
        },
        methods:{
            init(){
                var clock = new Cesium.Clock({
                    startTime : Cesium.JulianDate.fromIso8601('2017-07-11T00:00:00Z'),
                    stopTime : Cesium.JulianDate.fromIso8601('2017-07-11T24:00:00Z'),
                    currentTime : Cesium.JulianDate.fromIso8601('2017-07-11T10:00:00Z'),
                    clockRange : Cesium.ClockRange.LOOP_STOP,
                    clockStep : Cesium.ClockStep.SYSTEM_CLOCK_MULTIPLIER,
                    multiplier : 1000,
                    shouldAnimate : true
                });
                let vm = util.getViewer("csContainer",{
                    clockViewModel : new Cesium.ClockViewModel(clock),
                    shouldAnimate: true,
                    animation: true,
                    timeline: true,
                    // projectionPicker : true,
                    // terrainProvider: Cesium.createWorldTerrain()
                });
                let shadowMap = vw.shadowMap;
                shadowMap.maximumDistance = 1000.0;
                this.viewer = vm;
                this.dayTime()
            },
            setSpeed(){
                if (this.speed != null){
                    this.viewer.clock.multiplier = parseInt(this.speed);
                }

            },

            dayTime(){
                let viewer = this.viewer;
                // viewer.projectionPicker.viewModel.switchToOrthographic();
                viewer.scene.globe.enableLighting = true;
                viewer.scene.globe.depthTestAgainstTerrain = true;
                var position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);
                var heading = Cesium.Math.toRadians(180);
                var pitch = Cesium.Math.toRadians(2);
                var roll = Cesium.Math.toRadians(-6);
                var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                var orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);

                var entity = viewer.entities.add({
                    name : 'truck',
                    position : position,
                    // orientation : orientation,
                    model : {
                        uri : '/demo/static/data/models/people.glb',
                        // uri : '/demo/static/data/models/xuexiao.gltf',
                        heightReference : Cesium.HeightReference.CLAMP_TO_GROUND,
                        minimumPixelSize : 128,
                        maximumScale : 20,
                        scale : 0.05,
                        runAnimations : false
                    }
                });
                viewer.zoomTo(entity);
                // var frontView =  {
                //     destination : new Cesium.Cartesian3(-1371214.9554156072, -5508700.8494476415, 2901826.794611029),
                //     orientation : {
                //         heading : Cesium.Math.toRadians(80.5354269423926),
                //         pitch : Cesium.Math.toRadians(-15.466062969558285),
                //         roll : Cesium.Math.toRadians(359.9999999526579)
                //     },
                //     maximumHeight : 100
                // };
                // viewer.scene.camera.flyTo({
                //     destination : frontView.destination,
                //     orientation :  frontView.orientation,
                //     duration : 5.0,
                //     pitchAdjustHeight : 20
                // });



            }
        }
    }
</script>
<style scoped>
    .contain1{
            height: 50px;
    position: absolute;
        z-index: 999;
    }
    .speed{

        width:200px;


    }
    .submit {
       margin-left : 7px;


    }

  .shadow {

      color:white !important;

  }



  #csContainer {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: hidden;
  }
</style>
